export default "__VITE_ASSET__Dy1OMZtS__"